export function money(value) {
  return `S/${Number(value || 0).toFixed(2)}`;
}

export function cartSubtotal(cart) {
  return cart.reduce((sum, line) => {
    const addons = (line.selectedAddons || []).reduce(
      (addonSum, addon) => addonSum + Number(addon.price || 0),
      0,
    );
    return sum + (Number(line.price || 0) + addons) * Number(line.quantity || 0);
  }, 0);
}

export function distanceKm(from, to) {
  if (!from || !to) return 0;
  const rad = (value) => (Number(value) * Math.PI) / 180;
  const earth = 6371;
  const dLat = rad(Number(to.lat) - Number(from.lat));
  const dLng = rad(Number(to.lng) - Number(from.lng));
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(rad(from.lat)) * Math.cos(rad(to.lat)) * Math.sin(dLng / 2) ** 2;
  return earth * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

export function deliveryQuote(restaurant, address) {
  if (!restaurant || !address) return { distance: 0, charge: 0 };
  const distance = distanceKm(
    { lat: Number(restaurant.latitude), lng: Number(restaurant.longitude) },
    { lat: Number(address.lat), lng: Number(address.lng) },
  );

  if (restaurant.delivery_charge_type !== "DYNAMIC") {
    return {
      distance,
      charge: Number(restaurant.delivery_charges || 0),
    };
  }

  const base = Number(restaurant.base_delivery_charge || 0);
  const baseDistance = Number(restaurant.base_delivery_distance || 0);
  if (distance <= baseDistance) return { distance, charge: base };

  const stepDistance = Math.max(0.1, Number(restaurant.extra_delivery_distance || 1));
  const extra =
    ((distance - baseDistance) / stepDistance) *
    Number(restaurant.extra_delivery_charge || 0);

  return { distance, charge: Math.ceil(base + extra) };
}
